import { FC } from 'react';
import { FormattedMessage } from 'react-intl';

import { Timeline } from '@/shared/ui';

import { StructuredReportsAndStudiesType } from '@/features/reportCards';

import { useReportTimelineItem } from '../../hooks';
import { DetailsPopover } from '../DetailsPopover/DetailsPopover';
import { ReportCardFooter } from '../ReportCardFooter/ReportCardFooter';
import { ReportGenerationStatus } from '../ReportGenerationStatus/ReportGenerationStatus';

import styles from './ReportTimelineCard.module.scss';

type ReportTimelineCardProps = {
  structuredReportsAndStudies: StructuredReportsAndStudiesType;
  className?: string;
  showSource?: boolean;
  testID?: string;
};

export const ReportTimelineCard: FC<ReportTimelineCardProps> = (props) => {
  const { structuredReportsAndStudies, className, showSource, testID } = props;

  const item = useReportTimelineItem(structuredReportsAndStudies, {
    showSource,
  });

  if (!item) {
    return null;
  }

  return (
    <Timeline.Card
      className={className}
      dataComponent="report-timeline-card"
      time={item.time}
      title={item.title}
      meta={item.meta}
      preview={item.preview}
      previewFallback={
        item.isCompleted && !item.preview ? (
          <span className="p2">
            <FormattedMessage
              id="reportCard.preview.generationReady"
              defaultMessage="Report is ready."
            />{' '}
            <FormattedMessage
              id="reportCard.preview.generatingPreview"
              defaultMessage="Generating preview"
            />
          </span>
        ) : undefined
      }
      isHidden={item.isHidden}
      isRemoving={item.isRemoving}
      testID={testID}
      actions={<DetailsPopover {...item.detailsPopoverProps} />}
      onAuxClick={item.handleAuxClick}
      onClick={item.handleCardClick}
    >
      {!item.isCompleted && (
        <ReportGenerationStatus
          report={item.report}
          className={styles.status}
          compact
        />
      )}

      <ReportCardFooter className={styles.footer} light {...item.footerProps} />
    </Timeline.Card>
  );
};
